import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  MunilyTextFieldAppearance,
  MunilyTextFieldErrorMessages,
  MunilyTextFieldWidthLayout,
} from '../../../common-components/text-field/text-field.types';

@Component({
  selector: 'app-text-field-playground',
  templateUrl: './text-field-playground.component.html',
  styleUrls: ['./text-field-playground.component.scss'],
})
export class TextFieldPlaygroundComponent {
  readonly appearances: MunilyTextFieldAppearance[] = ['outlined', 'filled'];
  readonly sizes = ['default', 'small'] as const;
  readonly widthLayouts: MunilyTextFieldWidthLayout[] = ['ds', 'fill'];

  appearance: MunilyTextFieldAppearance = 'outlined';
  size: 'default' | 'small' = 'default';
  widthLayout: MunilyTextFieldWidthLayout = 'ds';
  /** Vacío = token DS (292px). Solo aplica con `widthLayout === 'ds'`. */
  maxWidthCustom = '';
  label = 'Etiqueta';
  placeholder = 'Escribe aquí…';
  hint = 'Texto de ayuda opcional';
  iconLeading = '';
  iconTrailing = '';
  prefixText = '';
  hasCharacterCounter = false;
  maxLength = 40;
  disabled = false;
  successful = false;

  readonly iconExamples = ['', 'search', 'mail', 'call', 'info'] as const;

  /** Vacío por defecto: el label en reposo no flota hasta que hay valor o foco (floatLabel auto). */
  demoControl = new FormControl('');
  fullNameControl = new FormControl('', Validators.required);
  emailControl = new FormControl('', [Validators.required, Validators.email]);

  emailErrorMessages: MunilyTextFieldErrorMessages = {
    required: 'El email es obligatorio',
    email: 'Ingresa un email válido',
  };

  markEmailTouched(): void {
    this.emailControl.markAsTouched();
  }

  markFullNameTouched(): void {
    this.fullNameControl.markAsTouched();
  }
}
